import { api } from 'api/api';
import axios from 'axios';
import type { ExportRequestsFilters } from 'state/normalized/requests/requestsSlice';

class ExportRequestsAPI {
  exportRequests = async (
    requestIds: string[],
    selectAll: boolean,
    filters?: ExportRequestsFilters
  ) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await api.post(
      'v2/request-exports/export-requests-as-csv',
      {
        requestIds,
        selectAll,
        timeZone,
        // CGP-221: only sent for select-all exports, where the backend
        // ignores requestIds and must re-apply the list's filters instead.
        ...(filters && { filters }),
      }
    );
    if (axios.isAxiosError(response)) {
      throw response;
    }

    return response.data.fileUrl;
  };

  exportRequestsByForm = async (
    requestIds: string[],
    selectAll: boolean,
    filters?: ExportRequestsFilters
  ) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await api.post(
      'v2/request-exports/export-requests-by-form-as-csv',
      {
        requestIds,
        selectAll,
        timeZone,
        ...(filters && { filters }),
      }
    );
    if (axios.isAxiosError(response)) {
      throw response;
    }
    return response.data.fileUrl;
  };
}

const exportRequestsAPI = new ExportRequestsAPI();

export default exportRequestsAPI;
